import React from 'react';

import styles from './LoadingSpinner.module.scss';

type Props = {
    size?: number | `${number}${'px' | 'em'}`;
    includeWrapper?: boolean;
};

function LoadingSpinner({ size = 120, includeWrapper = true }: Props) {
    const loadingSpinnerSvg = (
        <svg
            className="loading-spinner"
            data-testid="loading-spinner"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 150 150"
            width={size}
            height={size}
        >
            <animateTransform
                attributeName="transform"
                type="rotate"
                values="0;360;360;360"
                dur="3s"
                repeatCount="indefinite"
            />
            <circle cx="117.8" cy="100" r="25" fill="#ffd503">
                <animateTransform
                    attributeName="transform"
                    type="translate"
                    values="0,0;0,0;-43.3,-25;0,0"
                    dur="3s"
                    repeatCount="indefinite"
                />
            </circle>
            <circle cx="31.2" cy="100" r="25" fill="#f7a238">
                <animateTransform
                    attributeName="transform"
                    type="translate"
                    values="0,0;0,0;43.3,-25;0,0"
                    dur="3s"
                    repeatCount="indefinite"
                />
            </circle>
            <circle cx="74.5" cy="25" r="25" fill="#1b73aa">
                <animateTransform
                    attributeName="transform"
                    type="translate"
                    values="0,0;0,0;0,50;0,0"
                    dur="3s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    );
    return (
        <>
            {includeWrapper ? (
                <div className={styles['wrapper']}>{loadingSpinnerSvg}</div>
            ) : (
                loadingSpinnerSvg
            )}
        </>
    );
}

export default React.memo(LoadingSpinner);
